import React, { useState, useEffect } from 'react';
import { Calendar, Clock, Settings, CalendarDays, Trophy } from 'lucide-react';
import {
  PAGE_TOP_PADDING,
  CONTENT_MAX_WIDE,
  CONTENT_INSET,
  SECTION_PADDING,
} from '../styles/layout';
import { GOLD, BG, TEXT_MUTED } from '../constants/booking';
import { LEAGUE_COMING_SOON } from '../constants/league';

const SECTION_PADDING_TIGHT = 'clamp(1.25rem, 3vw, 2.5rem) clamp(1rem, 4vw, 2rem)';

const AdminLayout = ({ children, activeTab, setActiveTab }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const tabs = [
    { id: 'bookings', name: 'Bookings', icon: Calendar },
    { id: 'calendar', name: 'Calendar', icon: CalendarDays },
    { id: 'availability', name: 'Availability', icon: Clock },
    ...(LEAGUE_COMING_SOON ? [] : [{ id: 'league', name: 'League', icon: Trophy }]),
    { id: 'settings', name: 'Settings', icon: Settings },
  ];

  return (
    <div
      style={{
        backgroundColor: BG,
        minHeight: '100vh',
        paddingTop: PAGE_TOP_PADDING,
        paddingBottom: SECTION_PADDING,
      }}
    >
      <div
        style={{
          maxWidth: CONTENT_MAX_WIDE,
          margin: '0 auto',
          padding: `0 ${CONTENT_INSET}`,
          width: '100%',
          boxSizing: 'border-box',
        }}
      >
        <header style={{ textAlign: 'center', marginBottom: isMobile ? '1.5rem' : '2rem' }}>
          <h1
            style={{
              fontSize: isMobile ? '1.75rem' : '2.25rem',
              fontWeight: '800',
              color: GOLD,
              margin: '0 0 0.5rem',
              lineHeight: 1.15,
            }}
          >
            Admin
          </h1>
          <p style={{ color: TEXT_MUTED, fontSize: '1.0625rem', margin: 0 }}>
            Manage bookings, availability, and settings
          </p>
        </header>

        <nav
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: isMobile ? '0.25rem 0.75rem' : '0.5rem 1.25rem',
            marginBottom: isMobile ? '1.5rem' : '2rem',
            borderBottom: '1px solid rgba(201, 168, 76, 0.2)',
            paddingBottom: '0.25rem',
          }}
          aria-label="Admin sections"
        >
          {tabs.map((tab) => {
            const Icon = tab.icon;
            const isActive = activeTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                onClick={() => setActiveTab(tab.id)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.4rem',
                  padding: '0.5rem 0.25rem 0.65rem',
                  background: 'none',
                  border: 'none',
                  borderBottom: isActive ? `2px solid ${GOLD}` : '2px solid transparent',
                  color: isActive ? GOLD : '#d1d5db',
                  fontWeight: isActive ? '700' : '500',
                  fontSize: isMobile ? '0.8125rem' : '0.9375rem',
                  cursor: 'pointer',
                  whiteSpace: 'nowrap',
                }}
              >
                <Icon size={isMobile ? 16 : 18} />
                {tab.name}
              </button>
            );
          })}
        </nav>

        <main>{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
